<template>
  <div class="copyright-container">
    <div class="contact-info">
      <div>
        CopyRight © 2020 zjmegroup.cn 浙江省机电集团有限公司 All Rights
        Reserved.
      </div>
      <div>联系电话：{{ data.tel || "" }}</div>
      <div>E-Mail: {{ data.email || "" }}</div>
    </div>
    <div class="copyright-info">
      <div class="copyright-info-item" @click="handleTo(1)">
        <img :src="ICON_IMAGE" alt="" />浙ICP备14033092号-1
      </div>
      <div class="copyright-info-item" @click="handleTo(2)">
        <img :src="ICON_IMAGE" alt="" />浙公网安备{{ recordcode }}号
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
// 组件
import { ElMessageBox } from "element-plus";
// 静态资源
import ICON_IMAGE from "@/assets/hui_image.png";

const recordcode = "33010202004974";
const hrefMap = {
  1: {
    href: "https://beian.miit.gov.cn/",
  },
  2: {
    href: `https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${recordcode}`,
  },
};

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});

const handleTo = (type) => {
  const href = hrefMap[type].href;
  window.open(href, "_blank");
};

onMounted(() => {});
</script>

<style lang="less" scoped>
@gap: 50px;
.copyright-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  background: #575757;
  color: #fff;
  font-family: LucidaGrande;
  line-height: 2em;
  .contact-info {
    display: flex;
    justify-content: center;
    & > div:nth-child(n + 2) {
      margin-left: @gap;
    }
  }
  .copyright-info {
    display: flex;
    justify-content: center;
    .copyright-info-item {
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover {
        color: #7ccbff;
      }
      &:nth-child(n + 2) {
        margin-left: @gap;
      }
      & > img {
        width: 19px;
        height: 20px;
        margin-right: 5px;
      }
    }
  }
}
</style>

<style lang="less">
.copyright-msg-box {
  --el-messagebox-width: 400px;
}
</style>
